import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { END } from 'redux-saga';
import Head from 'next/head';
import { connect } from 'react-redux';
import { wrapper } from '~/store';
import nextI18nextConfig from '~/../next-i18next.config';
import defaultStaticPage, {
  defaultPageStaticContext,
} from '~/../hocs/defaultStaticPage';
import Layout from '~/containers/Layout';
import CuratedContainer from '~/containers/CuratedPage';
import { loadRecommendData } from '~/containers/CuratedPage/actions';
import config, { keyConfig } from '~/config';
import HrefLangs from '~/components/HrefLangs';

@connect((state) => ({
  photos: state.recommendPage.result.photos,
  location: state.recommendPage.result.query,
  totalItem: state.recommendPage.result.totalItem,
  totalPage: state.recommendPage.result.totalPage,
  dataCurated: state.recommendPage.result,
}))
@defaultStaticPage()
class RecommendPage extends React.Component {
  // renderAsPath = (query, route_recommend_page) => {
  //   query = Object.assign({}, query);
  //   const url = `/${route_recommend_page}/`;
  //   let params = '';
  //   let isFirstIndex = true;
  //   forOwn(query, (query, key) => {
  //     if (Array.isArray(query)) {
  //       query = query.map(({ query }) => query).toString();
  //     }

  //     if (query && key !== 'is_tag' && key !== 'lng' && key !== 'token') {
  //       if (isFirstIndex) {
  //         params = params.concat(`?${key}=${query}`);
  //         isFirstIndex = false;
  //       } else {
  //         params = params.concat(`&${key}=${query}`);
  //       }
  //     }
  //   });
  //   return url + params;
  // };

  render() {
    const {
      t,
      lng,
      photos,
      location,
      totalPage,
      totalItem,
      slug,
      dataCurated,
    } = this.props;
    const canonical = `${config.getSiteURL()}/curated/${encodeURIComponent(
      slug,
    )}`;

    const hrefPrev = `${canonical}/${parseInt(location.page) - 1}`;
    const hrefNext = `${canonical}/${parseInt(location.page) + 1}`;
    const page = parseInt(location.page);

    const data = photos.length ? photos[0] : {};
    const patternData = dataCurated.patternData;
    const metaData =
      patternData?.meta_description &&
      JSON.parse(patternData?.meta_description);
    const meta_description = metaData
      ? metaData[`meta_description_${lng}`] || metaData['meta_description_en']
      : null;
    const titleData =
      patternData?.title_tag && JSON.parse(patternData?.title_tag);

    let title_tag = titleData
      ? titleData[`title_tag_${lng}`] || titleData['title_tag_en']
      : null;
    if (title_tag) {
      if (page > 1) {
        const PageText = t(config.getPrefixContent('page_count'), {
          page: page,
        });
        title_tag += ' ' + PageText;
      } else {
        title_tag += t(config.getPrefixContent('title_tag'));
      }
    }
    const nameData = patternData?.names && JSON.parse(patternData?.names);
    const name = nameData ? nameData[`name_${lng}`] || nameData['name_en'] : '';
    const titleDefault =
      page > 1
        ? t(keyConfig.get('title_recommend_page_page'), { page: page })
        : t(keyConfig.get('title_recommend_page'));
    return (
      <Layout>
        <Head>
          <title>{title_tag || titleDefault}</title>
          {parseInt(location.page) === 1 ? (
            ''
          ) : (
            <link rel="prev" href={hrefPrev} />
          )}
          {parseInt(location.page) >= totalPage ? (
            ''
          ) : (
            <link rel="next" href={hrefNext} />
          )}
          <meta
            id="meta-keywords"
            name="keywords"
            content={t(keyConfig.get('meta_keywords_recommend_page'))}
          />
          <meta
            id="meta-description"
            name="description"
            content={
              meta_description ||
              t(config.getPrefixContent('meta_description_curated_default'), {
                count: totalItem,
                nameCurated: name,
              })
            }
          />
          <HrefLangs
            pagePath={`/curated/${encodeURIComponent(slug)}${
              page === 1 ? '' : `/${page}`
            }`}
            lng={lng}
          />
          <meta
            property="og:image"
            content={`${
              config.staticPrefix
            }/static/assets/image/logo/${config.renderImagePage()}`}
          />
          <meta
            property="og:title"
            content={t(keyConfig.get('title_recommend_page'), {
              total: totalItem,
            })}
          />
          <meta property="og:type" content="article" />
          <meta
            property="og:description"
            content={t(keyConfig.get('meta_description_recommend_page'))}
          />
          <meta
            property="og:url"
            content={`${canonical}${page === 1 ? '' : `/${page}`}`}
          />

          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:url"
            content={`${canonical}${page === 1 ? '' : `/${page}`}`}
          />
          <meta
            name="twitter:title"
            content={t(keyConfig.get('title_recommend_page'))}
          />
          <meta
            name="twitter:description"
            content={t(keyConfig.get('meta_description_recommend_page'), {
              total: totalItem,
            })}
          />
          <meta name="twitter:image" content={data.path || ''} />
          <meta name="twitter:site" content={`${config.getSiteURL()}`} />
          <meta name="twitter:creator" content={`@${config.getName()}`} />
        </Head>
        <CuratedContainer
          t={t}
          lng={lng}
          slug={slug}
          patternData={patternData}
        />
      </Layout>
    );
  }
}

export const getStaticPaths = async () => {
  const paths = [];

  return { paths, fallback: 'blocking' };
};

export const getStaticProps = wrapper.getStaticProps((store) => async (ctx) => {
  const i18nProps = await serverSideTranslations(
    ctx.locale || process.env.LANGUAGE,
    ['common'],
    nextI18nextConfig,
  );
  const { currentLanguage, api } = await defaultPageStaticContext({
    ...ctx,
    store,
  });

  const clientIp = '1.1.1.1';
  const { params } = ctx;

  const language = currentLanguage;

  let slug = params?.slug;
  let id = params.pattern_id || -1;
  if (slug) {
    const arrayHandle = slug.split('-');
    id = arrayHandle[arrayHandle.length - 1];
  }
  if (id !== -1) {
    store.dispatch(
      loadRecommendData(
        {
          order_by: params.order_by || 'popular',
          lang: language,
          pattern_id: id,
          page: params.page,
          per_page: params.per_page || 100,
          clientIp,
        },
        api,
      ),
    );
  }

  // end the saga
  store.dispatch(END);
  await store.sagaTask.toPromise();

  return {
    props: {
      ...i18nProps,
      currentLanguage,
      slug: slug || null,
      query: params,
    },
    revalidate: 60 * 60 * 24 * 7, // revalidate every 7 days
  };
});

export default RecommendPage;
